import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
 
  // Disable all console output in production
  window.console.log = () => {};
  window.console.warn = () => {};
  window.console.error = () => {};
  window.console.info = () => {};
  window.console.debug = () => {};
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(success => console.log(`Rondeivu App Start Success!`))
  .catch(err => console.error(err));
